import React from 'react';

interface TimelineItemProps {
  id: number;
  content: string;
  start: string;
  end: string;
  title: string;
}

const TimelineItem: React.FC<TimelineItemProps> = ({ content, start, end, title }) => (
  <div style={{ marginBottom: 40, paddingLeft: 30, borderLeft: '3px solid #1976d2', position: 'relative' }}>
    <div style={{ position: 'absolute', left: -9, top: 10, width: 14, height: 14, borderRadius: '50%', background: '#1976d2', border: '3px solid #f5f5f5' }} />
    <div style={{ background: 'white', padding: 20, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
      <h2 style={{ margin: '0 0 5px', color: '#1976d2', fontSize: 20 }}>{content}</h2>
      <div style={{ color: '#666', fontSize: 13, marginBottom: 10, fontWeight: 'bold' }}>
        {new Date(start).getFullYear()} - {new Date(end).getFullYear()}
      </div>
      <p style={{ margin: 0, color: '#333', lineHeight: 1.5 }}>{title}</p>
    </div>
  </div>
);

export default TimelineItem;

